export default "__VITE_ASSET__D3CG68kl__"